import { render, staticRenderFns } from "./AboutUsInfo.vue?vue&type=template&id=1b19f08e&scoped=true&"
import script from "./AboutUsInfo.vue?vue&type=script&lang=js&"
export * from "./AboutUsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsInfo.vue?vue&type=style&index=0&id=1b19f08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b19f08e",
  null
  
)

export default component.exports